const microphonePermissionStates = {
    GRANTED: 'granted',
    DENIED: 'denied',
    PROMPT: 'prompt',
    // No Permissions API or no 'microphone' support (Safari) - known only after asking
    UNKNOWN: 'unknown',
};

export default microphonePermissionStates;
